import React, { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import DocumentSelectorModal from "./DocumentSelectorModal";

export default function CreditNoteInfo({
  persona,
  facturaRelacionadaId,
  facturaRelacionadaNumero,
  facturaRelacionadaClaveAcceso,
  motivoTipo,
  onDocumentSelected,
  onChange,
  mobile = false,
}) {
  const [open, setOpen] = useState(false);

  const hasDocument = Boolean(facturaRelacionadaId);

  const handleMotivoChange = (e) => {
    const value = e.target.value;

    onChange?.({
      nota_credito_motivo_tipo: value,
      es_devolucion: value === "DEVOLUCION",
      es_ajuste: value === "AJUSTE",
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          p: mobile ? 1.5 : 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          bgcolor: "#fafafa",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#333", mb: 1 }}>
          Documento relacionado
        </Typography>

        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: "#1565C0", mb: 1.5 }}
          fullWidth={mobile}
        >
          Seleccionar documento
        </Button>

        {hasDocument ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              label="Factura relacionada"
              value={facturaRelacionadaNumero || ""}
              InputProps={{ readOnly: true }}
              fullWidth={mobile}
              sx={{ minWidth: mobile ? "100%" : 350 }}
            />
            <TextField
              label="Clave de acceso"
              value={facturaRelacionadaClaveAcceso || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Box>
        ) : (
          <Typography sx={{ fontSize: 13, color: "#777" }}>
            Selecciona una factura para cargar automáticamente sus productos.
          </Typography>
        )}

        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontWeight: 700, color: "#333", mb: 0.75 }}>
            Tipo de nota de crédito
          </Typography>
          <Select
            value={motivoTipo || "DEVOLUCION"}
            onChange={handleMotivoChange}
            fullWidth={mobile}
            sx={{ minWidth: mobile ? "100%" : 280 }}
          >
            <MenuItem value="DEVOLUCION">Devolución</MenuItem>
            <MenuItem value="AJUSTE">Ajuste</MenuItem>
          </Select>
        </Box>
      </Paper>

      <DocumentSelectorModal
        open={open}
        onClose={() => setOpen(false)}
        persona={persona}
        title="Seleccionar factura para nota de crédito"
        tipo="FACTURA"
        endpoint="/facturas/notas-credito/facturas-cliente/"
        detailEndpoint="/facturas/notas-credito/detalle-factura/"
        onSelected={onDocumentSelected}
      />
    </Box>
  );
}